import React from 'react';
import { Link } from 'react-router-dom';
import useFirebase from '../../Hooks/useFirebase';

const Register = () => {
    const { signInUsingGoogle } = useFirebase();
    return (
        <div className="text-center">
            <div>
                <h2>Register: Create Account</h2>
                <form onSubmit="">
                    <input type="email" name="" id="" placeholder="Your Email" />
                    <br />
                    <input type="password" name="" id="" placeholder="Your Password" />
                    <br />
                    <input type="password" name="" id="" placeholder="Re-enter Password" />
                    <br />
                    <input type="submit" value="Submit" />
                </form>
                <p>Already have an Account? <Link to="/login">Login</Link></p>
                <div className="mb-4">__________________OR_________________</div>
                {/* <button className="btn-regular mb-3">Google Sign In</button> */}
                <button className="btn-regular mb-3" onClick={signInUsingGoogle}>Google Sign In</button>
            </div>
        </div>
    );
};

export default Register;